import React, { useCallback, useState } from 'react';
import { Box, styled } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';

import { LoginContainer } from '@paragon/login-tools';
import { Notifier, NotifierDialog } from '@paragon/notification-tools';

import accountsLogoUrl from '../../resources/accounts.png';
import { logInSuccessFollowUp } from '../actions/authenticationActions';
import Content from './Content';
import { Header } from './header/Header';
import { useAppDispatch } from './hooks';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(({ theme }) => ({
  // Clear the permanent nav drawer, which collapses into a temporary one on small screens
  '&.notistack-MuiContent': { color: 'white', marginLeft: 295, [theme.breakpoints.down('md')]: { marginLeft: 0 } },
}));

export function RootComponent() {
  const dispatch = useAppDispatch();
  const [navOpen, setNavOpen] = useState(false);
  const closeNav = useCallback(() => setNavOpen(false), []);

  return (
    <>
      <CssBaseline />
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        maxSnack={3}
        Components={{
          default: StyledMaterialDesignContent,
          success: StyledMaterialDesignContent,
          error: StyledMaterialDesignContent,
          warning: StyledMaterialDesignContent,
          info: StyledMaterialDesignContent,
        }}
      >
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
          }}
        >
          <Notifier />
          <NotifierDialog />
          <LoginContainer
            clientName="Accounts"
            requirePermission="accounts-access"
            clientLogoUrl={accountsLogoUrl}
            onLogIn={(user) => {
              dispatch(logInSuccessFollowUp(user));
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                height: 430,
                zIndex: 1,
                overflow: 'hidden',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Header onNavigationMenuClick={() => setNavOpen(true)} />
              <Content navOpen={navOpen} onNavClose={closeNav} />
            </Box>
          </LoginContainer>
        </Box>
      </SnackbarProvider>
    </>
  );
}
